import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { FormularQuerySorterConfig } from 'fa-kt.types';
import { FormularService } from '../service';

@Component({
  selector: 'fa-kt-formular-sorter',
  templateUrl: './formular-sorter.component.html',
  styleUrls: ['./formular-sorter.component.css'],
})
export class FormularSorterComponent {
  public FormularSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public formular: FormularService,
  ) {
    this.FormularSorterConfig = FormularQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
